import { ATTRIBUTE_LABELS } from '../data/mockVtubers';
import StreamHeatmap, { DAY_LABELS, DAY_ORDER } from './StreamHeatmap';

const boxStyle = {
  background: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
};

const styles = {
  trendRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    alignItems: 'stretch',
  },
  trendCol: {
    ...boxStyle,
    flex: '1 1 260px',
    minWidth: '260px',
  },
};

function StreamTrends({ vtuber }) {
  return (
    <div style={styles.trendRow}>
      <section style={styles.trendCol}>
        <h3>配信傾向</h3>
        <p>
          配信曜日:{' '}
          {DAY_ORDER.filter((day) =>
            vtuber.attributes.some((attribute) => attribute.approved && attribute.value === day),
          )
            .map((day) => DAY_LABELS[day])
            .join('・') || '未設定'}
        </p>
        <p>
          配信時間帯:{' '}
          {ATTRIBUTE_LABELS[
            vtuber.attributes.find(
              (attribute) => attribute.approved && attribute.value.startsWith('stream_time_'),
            )?.value
          ] || '未設定'}
        </p>
        <p>
          配信頻度:{' '}
          {ATTRIBUTE_LABELS[
            vtuber.attributes.find(
              (attribute) =>
                attribute.approved && attribute.value.startsWith('stream_frequency_'),
            )?.value
          ] || '未設定'}
        </p>
      </section>

      <section style={styles.trendCol}>
        <h3>配信時間帯ヒートマップ</h3>
        <StreamHeatmap videos={vtuber.videos} />
      </section>
    </div>
  );
}

export default StreamTrends;
